module.exports = __webpack_public_path__ + "media/configurations/P-X-aa8a7bbb.png";